<!--
 * @Description: 运营总览画像饼图组件
 * @Author:shh
 * @Date: 2022-07-14 17:33:29
 * @LastEditTime: 2022-07-14 18:33:29
-->
<template>
  <div class="PieChartsDialog">
    <div style="width: 100%; height: 100%" :id="id" class="echarts" ref="echarts"></div>
  </div>
</template>
<script>
export default {
  name: 'PieChartsDialog',
  data() {
    return {
      arr: [],
    }
  },

  props: ['id', 'chartData', 'nameData', 'title', 'color', 'name'],

  created() {
    this.initData();
  },

  mounted() {
    this.drawCharts();
  },

  watch: {
    //子组件监听父组件数据实时更新
    chartData: {
      handler(_newValue, _oldValue) {
        this.arr.length = 0;
        this.initData();
        this.drawCharts();
      },
      deep: true
    }
  },
  
  methods: {
    drawCharts() {
      let myChart = this.echarts.init(document.getElementById(this.id));
      myChart.setOption({
        color: this.color,
        title: {
          text: this.title,
          left: 'center',
          top: 25,
          textStyle: { 
          color: '#000000 ', //文字颜色    
          fontStyle: 'normal', //字体风格,'normal','italic','oblique'
          //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
          fontWeight: 'bold',
          fontFamily: 'PingFangSC-Semibold, PingFang SC',  //字体系列 
          fontSize: 18, //字体大小
          lineHeight: "30", // 行高
          width: "130",//宽度
          }
        },
        tooltip: {
          trigger: 'item',
          show: true,
            formatter: (params) => {
              return (params.marker + params.name + `&nbsp&nbsp&nbsp` + params.percent + '%' + `&nbsp&nbsp` )
            },
            color: "black",
            textStyle: {
　　           align: 'left',
              // color: "black",
　　        },
            padding: [5, 10],
            // backgroundColor: "#FFFFFF", 
            // borderWidth: "1", //边框宽度设置1
            // borderColor: "#333", //设置边框颜色  
          },
          grid: {
            top: '40',
		        left: '20',
		        right: '20',
		        bottom: '70',
		        containLabel: true
		      },
          legend: {
            top: 428,
            bottom : 20,
            itemWidth: 25,
            itemHeight: 14,
            // borderWidth : 1,
            // borderColor :'#CCCCCC',
          },
          series: [
            {
              type: 'pie',
              radius : '50%',//设置饼图大小
              center: ['50%', '50%'],   //圆的位置
              label: {
                normal: {
                  textStyle: {
                    color: '#000000'  // 改变标示文字的颜色
                  }
                }
              },
              data: this.arr,
              emphasis: {
                itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              }   
            }
          }
        ]
      })
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    },
    initData() {
      this.arr = this.chartData;
    }
  }
}
</script>
<style  scoped>
 .PieChartsDialog {
  height: 484px;
 }
</style>



// WEBPACK FOOTER //
// src/components/overview/components/CommonPieCharts.vue